const PREVIEW_HOSTS = ["winabc.xyz", "localhost", "127.0.0.1"];

/**
 * Staging only: ?theme=<key> renders that landing page directly, so QC can see
 * one no domain maps to without anyone editing getDomainFallbackPage by hand.
 *
 * Nothing is remembered — the URL carries the whole state, so a bare host always
 * shows what the domain says, and production ignores the parameter outright.
 */
export const getPreviewTheme = (): string | null => {
  if (typeof window === "undefined") return null;

  try {
    if (!PREVIEW_HOSTS.includes(window.location.hostname)) return null;
    return new URLSearchParams(window.location.search).get("theme");
  } catch {
    return null;
  }
};
